import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const IMG = "https://images.unsplash.com/photo-1774557937014-7bb9ffcd2469?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHx2b2x1bnRlZXJzJTIwY29tbXVuaXR5JTIwaGVscGluZ3xlbnwwfHx8fDE3ODgyMTAwNzF8MA&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back!");
      navigate("/admin");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-brand-bg" data-testid="login-page">
      <div className="hidden lg:block relative">
        <img src={IMG} alt="Volunteer community" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/15" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <p className="overline text-white/80">Admin console</p>
          <h2 className="font-heading text-4xl font-light tracking-tight mt-3 max-w-sm">
            Track every hour. Honor every volunteer.
          </h2>
        </div>
      </div>

      <div className="flex items-center justify-center p-8 sm:p-16">
        <div className="w-full max-w-sm">
          <Link to="/" className="text-sm text-brand-muted hover:text-brand-primary transition-colors font-body" data-testid="back-to-clock-link">
            ← Back to time clock
          </Link>
          <h1 className="font-heading text-4xl font-light tracking-tight mt-8">Sign in</h1>
          <p className="text-brand-muted font-body mt-2">Access your admin dashboard.</p>

          <form onSubmit={submit} className="mt-10 space-y-5">
            <div>
              <Label htmlFor="email" className="overline block mb-2">Email</Label>
              <Input
                id="email"
                type="email"
                data-testid="login-email-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="h-12 bg-white border-brand-border font-body"
              />
            </div>
            <div>
              <Label htmlFor="password" className="overline block mb-2">Password</Label>
              <Input
                id="password"
                type="password"
                data-testid="login-password-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="h-12 bg-white border-brand-border font-body"
              />
            </div>
            <button
              type="submit"
              data-testid="login-submit-button"
              disabled={loading}
              className="w-full h-12 rounded-md bg-brand-primary text-white font-heading font-medium transition-colors hover:bg-brand-primaryHover disabled:opacity-50"
            >
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>

          <p className="mt-6 text-sm text-brand-muted font-body">
            No account yet?{" "}
            <Link to="/register" className="text-brand-primary hover:underline" data-testid="go-register-link">
              Create one
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
